import FirebaseContext, { withFirebase } from './firebase-context'
import Firebase from './firebase'

export default Firebase

export { FirebaseContext, withFirebase }